module.exports = __webpack_public_path__ + "media/pro/edb-logo-43ac2291.png";